import {isEmpty} from "lodash"
import querystring from "querystring"
import injectRoute from "./injectRoute"

export const injectRouteWithQuery = (path, {params = {}, queryParams = {}, hash = ""}) => {
  let result = injectRoute(path, params)
  if (!isEmpty(queryParams)) {
    result = `${result}?${querystring.stringify(queryParams)}`
  }
  if (!isEmpty(hash)) {
    result = `${result}#${hash}`
  }
  return result
}

export default injectRouteWithQuery
